import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5zm0 15.733c-4.133 0-7.483-3.35-7.483-7.483S7.867 4.517 12 4.517c4.133 0 7.483 3.35 7.483 7.483s-3.35 7.483-7.483 7.483z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M9.599 12V8.354L15.913 12l-6.314 3.645z"
  })]
}), 'AppVideoPlay');